import { Linkable } from '@/components/blocks/Linkable';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { Button, Grid, Paper, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import {
	ClubDpRewardDescriptionSX,
	ClubDpRewardsActionSX,
	ClubDpRewardsPaperSX,
	ClubDpRewardsTitleSX,
	ClubDpRewardsSubTitleSX,
	ButtonRewardsSX,
	ButtonSecondRewardsSX,
} from '@/components/content/Account/styles/clubDpRewards';
import { useClubDpCardValidate } from '@/data/Content/ClubDp';
import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';

export const LinkCardView: React.FC = () => {
	const isMobile = useIsMobile();
	const [cardNumber, setCardNumber] = useState<string>('');
	const [error, setError] = useState<string>('');
	const { validateCard } = useClubDpCardValidate();

	const handleCardNumberChange = (event: React.ChangeEvent<HTMLInputElement>): any => {
		let { value, selectionStart } = event.target;
		const oldLength = value.length;

		value = value.replace(/\D/g, '');
		if (value.length > 16) {
			value = value.slice(0, 16);
		}
		value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
		const newLength = value.length;
		event.target.value = value;
		selectionStart = selectionStart ? selectionStart + (newLength - oldLength) : 0;
		event.target.setSelectionRange(selectionStart, selectionStart);
		setCardNumber(value);
		setError('');
	};

	const validateFields = (): boolean => {
		if (!cardNumber) {
			setError('Campo requerido.');
			return false;
		}
		const digitsOnly = cardNumber.replace(/\s/g, '');
		if (digitsOnly.length !== 16) {
			setError('El número de tarjeta debe tener 16 dígitos.');
			return false;
		}
		return true;
	};

	const handleLinkCard = async () => {
		if (!validateFields()) return;

		await validateCard(cardNumber.replace(/\s/g, ''));
	};

	const handleClick = () => {
		window.open('https://dpcardpuntos.com/', '_blank');
	};

	return (
		<React.Fragment>
			<Typography component={'h1'} sx={ClubDpRewardsTitleSX}>
				{'TUS DATOS CLUB DP REWARDS'}
			</Typography>
			<Stack direction={isMobile ? 'column' : 'row'} spacing={1} marginBottom={3}>
				<Typography sx={ClubDpRewardDescriptionSX}>
					{
						'Sigue acumulando puntos con tus compras para subir de nivel y obtén más beneficios exclusivos para ti.'
					}
				</Typography>
				<Linkable href="https://dpcardpuntos.com/" target="_blank">
					<Typography sx={ClubDpRewardsActionSX}>{'Conoce más'}</Typography>
				</Linkable>
			</Stack>
			<Paper sx={ClubDpRewardsPaperSX}>
				<Stack direction={'column'} spacing={1}>
					<Typography sx={ClubDpRewardsSubTitleSX}>
						{'INGRESA EL NÚMERO DE TU TARJETA PARA VINCULARLA A TU CUENTA'}
					</Typography>
					<Grid display={'flex'} flexDirection={isMobile ? 'column' : 'row'}>
						<DpOutlinedInput
							id="clubDpReward-linked"
							data-testid="clubDpReward-linked"
							name="clubDpRewardLinked"
							label={'Tarjeta Club dp puntos'}
							onChange={handleCardNumberChange}
							inputProps={{ maxLength: 19 }}
							fullWidth
							autoFocus={true}
							autoComplete=""
							required
							helperText={error ? error : ''}
							error={Boolean(error)}
						/>
						<Button
							sx={ButtonRewardsSX}
							id="clubDpReward--button"
							data-testid="clubDpReward-linked-button"
							variant="contained"
							onClick={handleLinkCard}
						>
							{'Vincular tarjeta'}
						</Button>
					</Grid>
				</Stack>
			</Paper>
			<Paper sx={ClubDpRewardsPaperSX}>
				<Stack
					direction={isMobile ? 'column' : 'row'}
					display={'flex'}
					alignItems={'center'}
					spacing={1}
				>
					<Typography sx={ClubDpRewardsSubTitleSX}>
						{
							'¿AÚN NO CUENTAS CON UNA? REGÍSTRATE Y COMIENZA A OBTENER BENEFICIOS EXCLUSIVOS POR TUS COMPRAS'
						}
					</Typography>
					<Button
						sx={ButtonSecondRewardsSX}
						id="clubDpReward-suscribe-button"
						data-testid="clubDpReward-suscribe-button"
						variant="contained"
						onClick={handleClick}
					>
						{'Registrate Ahora'}
					</Button>
				</Stack>
			</Paper>
		</React.Fragment>
	);
};
